module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/tools-8bbda8ebc65a593cb03067a926792ca5.svg";